import { MfeReactComponent } from '@carvana/microfrontend-react';
import React, { useContext, useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';
import { Step } from '|/app/services';
import Loading from '|/components/base/loading';
import { DevicePlatformContext, PageEventContext } from '|/context';
import PurchaseContext from '|/context/purchase-context';
import { loadVerifxMfe } from '|/hooks/use-global-mfe-config';
import useNavigateAwayFromPurchase from '|/hooks/use-navigate-away-from-purchase';
import useNavigateInPurchase from '|/hooks/use-navigate-in-purchase';
import useNavigateToNextStep from '|/hooks/use-navigate-to-next-step';

const VerifxMfeRoute: React.FC<{ step: Step | null }> = ({ step }) => {
  const { vehicleId } = useContext(PurchaseContext);
  const devicePlatform = useContext(DevicePlatformContext);
  const pageEventContext = useContext(PageEventContext);
  const navigateToNextStep = useNavigateToNextStep();
  const navigateInPurchase = useNavigateInPurchase();
  const navigateAwayFromPurchase = useNavigateAwayFromPurchase();

  const [shouldBlock, setShouldBlock] = useState(false);
  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    loadVerifxMfe();
  }, []);

  return (
    <MfeReactComponent
      module="PurchaseVerificationsModule"
      component="default"
      step={step}
      vehicleId={vehicleId}
      devicePlatform={devicePlatform}
      pageEventContext={pageEventContext}
      onNavigateToNextStep={navigateToNextStep}
      onNavigateInPurchase={navigateInPurchase}
      onNavigateAwayFromPurchase={navigateAwayFromPurchase}
      blocker={blocker}
      loading={<Loading />}
      setShouldBlock={setShouldBlock}
      onComponentError={({ id, error }: { id: string; error?: Error }) => {
        throw new Error(`Verifx MFE component failed: ${id}`, { cause: error });
      }}
    />
  );
};

export default VerifxMfeRoute;
